const LOGIN_MODE: 'mock' | 'sso' =
  process.env.REACT_APP_API_ENVIRONMENT === 'local' ? 'mock' : 'sso'
export const APP_RUNTIME_MODE = process.env.REACT_APP_API_ENVIRONMENT === 'mock' ? 'mock' : 'normal'

export { LOGIN_MODE }

const STS_AUTHORITY = process.env.REACT_APP_STS_AUTHORITY ?? ''
export const CLIENT_ID = process.env.REACT_APP_CLIENT_ID ?? ''

const CLIENT_ROOT = window.location.href.startsWith('http://localhost:3000')
  ? 'http://localhost:3000'
  : `${process.env.REACT_APP_CLIENT_ROOT}`

const CLIENT_SCOPE = 'openid offline_access'

export const OPEN_ID_SETTINGS = {
  authority: STS_AUTHORITY,
  client_id: CLIENT_ID,
  response_type: 'code',
  scope: CLIENT_SCOPE,
  redirect_uri: `${CLIENT_ROOT}/success`,
  silent_redirect_uri: `${CLIENT_ROOT}`,
  post_logout_redirect_uri: `${CLIENT_ROOT}`,
  // automaticSilentRenew is disabled because TokenExpWarn handles proactive token
  // refresh via its own setTimeout (~30 s before expiry). Keeping both active would
  // cause race conditions where the OIDC library's silent renew and the custom
  // refreshToken() call compete around the same deadline, potentially invalidating
  // each other's refresh token.
  // accessTokenExpiringNotificationTime: 1700,
  // automaticSilentRenew: true,
  automaticSilentRenew: false,
  // pkce: true,
}
